import { useMediaQuery } from "react-responsive";

import Navbar from "./NavBar";
import HomeDesktop from "./home/HomeDesktop";
import HomeMobile from "./home/HomeMobile";
import ExperienceDesktop from "./Experience/ExperienceDesktop";
import ExperienceMobile from "./Experience/ExperienceMobile";
import ConnectDesktop from "./Contact/ConnectDesktop";
import ConnectMobile from "./Contact/ConnectMobile";
import ProjectsDesktop from "./Projects/ProjectsDesktop";
import ProjectsMobile from "./Projects/ProjectsMobile";
import EducationDesktop from "./Education/EducationDesktop";
import BlogsMobile from "./Blogs/BlogsMobile";
import BlogsDesktop from "./Blogs/BlogsDesktop";

import EducationMobile from "./Education/EducationMobile";
import FooterDesktop from "./Footer/FooterDesktop";
import AwardDesktop from "./Honor and Award/AwardDesktop";
import AwardMobile from "./Honor and Award/AwardMobile";
import TeachingDesktop from "./Teaching/TeachingDesktop";
import TeachingMobile from "./Teaching/TeachingMobile";
import PublicationsDesktop from "./Publications/PublicationsDesktop";
import PublicationsMobile from "./Publications/PublicationsMobile";

function Core() {
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 1280 });
  const isMobile = useMediaQuery({ maxWidth: 1279 });

  return (
    <>
      <Navbar />
      <main
        className="ml-6 mr-6 
      md:mr-[120px] md:ml-[120px] 
      lg:mr-[200px] lg:ml-[200px] 
      xl:mr-[100px] xl:ml-[300px] 
      bg-gray-1">
        {isDesktopOrLaptop && (
          <div className="flex flex-col items-center">
            <div>
              <HomeDesktop />
              <ExperienceDesktop />
              <PublicationsDesktop />
              <TeachingDesktop />
              <EducationDesktop />
              <ProjectsDesktop />
              <AwardDesktop />
              <BlogsDesktop />
              <ConnectDesktop />
              <FooterDesktop />
            </div>
          </div>
        )}

        {isMobile && (
          <div className="flex flex-col items-center">
            <div>
              <HomeMobile />
              <ExperienceMobile />
              <PublicationsMobile />
              <TeachingMobile />
              <EducationMobile />
              <ProjectsMobile />
              <AwardMobile />
              <BlogsMobile />
              <ConnectMobile />
            </div>
          </div>
        )}
      </main>
    </>
  );
}

export default Core;
